<template>
  <pc v-if="!isMobile" />
  <mobile v-else />
</template>
<script>
import pc from './pc.vue';
import mobile from './mobile.vue';
export default {
    name: 'ContactUs',
    components: {
        pc, mobile,
    },
    computed: {
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
    },
};
</script>

<style scoped lang="scss">
</style>
